import { makeAutoObservable } from 'mobx';
import { RootStore } from '../RootStore';

export class UIStore {
  rootStore: RootStore;
  isLoading: boolean = false;
  error: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  };

  setError = (error: string | null) => {
    this.error = error;
  };
}
